import { Link } from "react-router-dom";
import { PackageSearch, HandCoins, Route, MessagesSquare, Headset, FileCheck, ArrowRight } from "lucide-react";
import { Reveal, SectionHeading, Beam } from "@/components/Reveal";
import { GraffitiTag } from "@/components/GraffitiTag";
import { Tilt } from "@/components/Tilt";
import { useContent } from "@/context/ContentContext";

const ICONS = {
  "load-search": PackageSearch,
  "rate-negotiation": HandCoins,
  "route-planning": Route,
  "broker-communication": MessagesSquare,
  "carrier-support": Headset,
  documentation: FileCheck,
};

export const Services = () => {
  const { content } = useContent();
  const services = content.services || [];

  return (
    <section id="services" data-testid="services-section" className="relative overflow-hidden py-20 lg:py-32 bg-surface border-y border-gold/10">
      <Beam />
      <GraffitiTag watermark rotate={-6} color="text-champagne" className="absolute -right-10 top-6 text-[26vw] lg:text-[13rem] leading-none pointer-events-none select-none hidden md:block">
        Dispatch
      </GraffitiTag>
      <div className="relative px-4 sm:px-8 lg:px-16 max-w-7xl mx-auto">
        <SectionHeading
          overline="Our Dispatching Services"
          title="Keep Your Truck Moving. Let Us Handle the Details."
          testId="services-heading"
          tag="Details Handled."
        />
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {services.map((s, i) => {
            const Icon = ICONS[s.key] || PackageSearch;
            return (
              <Reveal key={s.key || i} delay={0.06 * i} className="h-full">
                <Tilt max={7} className="h-full">
                  <article data-testid={`service-card-${s.key || i}`} className="card-gold p-6 sm:p-8 h-full flex flex-col group">
                    <div className="w-12 h-12 flex items-center justify-center border border-gold/40 bg-gold/5 mb-6 group-hover:bg-gold/15 group-hover:border-gold transition-colors duration-300">
                      <Icon size={22} className="text-gold" />
                    </div>
                    <h3 className="font-display text-xl sm:text-2xl font-semibold uppercase tracking-wide text-white mb-3">
                      {s.title}
                    </h3>
                    <p className="text-sm text-zinc-400 leading-relaxed flex-1">{s.description}</p>
                    <Link
                      to="/become-a-carrier"
                      data-testid={`service-learn-more-${s.key || i}`}
                      className="mt-6 inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-gold hover:text-champagne transition-colors duration-300"
                    >
                      Learn More
                      <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform duration-300" />
                    </Link>
                  </article>
                </Tilt>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
